import { useEffect, useState } from 'react';
import axios from 'axios';
// http://192.168.101.5:5001
export default function useLiveEphemeris() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const baseURL = process.env.NODE_ENV === 'production' ? '' : (process.env.REACT_APP_API_BASE_URL || `http://${window.location.hostname}:5001`);
        const response = await axios.get(`${baseURL}/api/ephemeris/current?include=planets`);
        console.log("%c🌟 Live Ephemeris Synced", "color: #b08d57; font-size: 12px; font-weight: bold; background: #1a1a24; padding: 4px; border-radius: 4px;");

        setData(response.data);
      } catch (err) {
        console.error('❌ Error fetching ephemeris data:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  return { data, loading, error };
}
